import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperclip1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPaperclip1"><Path d="M5.5 10.5V15.5C5.5 18.8137 8.18629 21.5 11.5 21.5C14.8137 21.5 17.5 18.8137 17.5 15.5V6.5C17.5 4.29086 15.7091 2.5 13.5 2.5C11.2909 2.5 9.5 4.29086 9.5 6.5V15.5C9.5 16.6046 10.3954 17.5 11.5 17.5C12.6046 17.5 13.5 16.6046 13.5 15.5V7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPaperclip1;
